{
  "moreActions": "Дополнительные действия"
}
